var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.allRead
    ? _c(
        "v-list-item",
        {
          on: {
            click: function($event) {
              return _vm.$emit("readAllNotifications", "read")
            }
          }
        },
        [
          _c("v-list-item-title", [
            _vm._v("\n    " + _vm._s(_vm.actions.markAllAsRead) + "\n  ")
          ])
        ],
        1
      )
    : _c(
        "v-list-item",
        {
          on: {
            click: function($event) {
              return _vm.$emit("readAllNotifications", "unread")
            }
          }
        },
        [
          _c("v-list-item-title", [
            _vm._v("\n    " + _vm._s(_vm.actions.markAllAsUnread) + "\n  ")
          ])
        ],
        1
      )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2f263c91", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2f263c91","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Management/Notifications/_Molecules/NotificationReadAllMenu.vue
// module id = null
// module chunks = 